import React from 'react'
import { useEffect, useRef, useState } from "react"
import Loading from './Loading'

export const QuestionImage = ({dataUrl}) => {

    const [loading, setLoading] = useState(true)

    const imageRef = useRef()

    useEffect(() =>{
        setLoading(true)
            if(imageRef.current) {
                imageRef.current.src = dataUrl;
            }
    },[dataUrl])


    return (
        <>
            <Loading loading={loading}>
                <div></div>
            </Loading>
            <img key={dataUrl} ref={imageRef} onLoad={() => setLoading(false)}/>
        </>
    )
}